import React, { memo } from 'react';
import {useSelector} from 'react-redux';
import styles from './styles.module.scss';

const Index = memo(() => {
  const recReSizeReducer = useSelector(({recReSizeReducer}) => recReSizeReducer.value);

  // 样式判断
  const normal = () => {
    return styles.normal;
  };

  const templateScroll = () => {
      return (
        <>
         <div className='scrollTitle'>
          <span>SCROLL</span>
        </div>
         <div className='groupArrow'>
            <div className={`arrowLine ${recReSizeReducer <= 750 ? styles.scrollDownM : styles.scrollDown}`}  />
          </div>
        </>
      )
  }

  // 判断是：桌面/移动端
  const desktopMobile = () => {
    return templateScroll();
  };


  return (
      <div className={normal()}>
        {desktopMobile()}
      </div>
  );
});
export default Index;
